"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-select-dropdown el-popper",
    "class": [{
      'is-multiple': _vm.$parent.multiple
    }, _vm.popperClass],
    style: {
      minWidth: _vm.minWidth
    },
    attrs: {}
  }, [_vm._t("default", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElSelectDropdown',
  componentName: 'ElSelectDropdown',
  mixins: [_vuePopper["default"]],
  props: {
    placement: {
      "default": 'bottom-start'
    },
    boundariesPadding: {
      "default": 0
    },
    popperOptions: {
      "default": function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },
    visibleArrow: {
      "default": true
    },
    appendToBody: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      minWidth: ''
    };
  },
  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },
  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
};
exports["default"] = _default2;